import * as React from "react";
import { v4 as uuid } from "uuid";
import axios from "axios";

import Box from "@mui/material/Box";
import Fab from "@mui/material/Fab";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
import { useSnackbar } from "notistack";
import { EmailHeaderLine } from "../molecules/EmailHeaderLine";
import { EmailToLine } from "../molecules/EmailToLine";
import { EmailCcLine } from "../molecules/EmailCcLine";
import { EmailBccLine } from "../molecules/EmailBccLine";
import { EmailSubjectLine } from "../molecules/EmailSubjectLine";
import { EmailFooterLine } from "../molecules/EmailFooterLine";
import { TipTap } from "../organisms/TipTap";
import { zohoApi } from "../../zohoApi";
import { staticToDynamicEmail, validateEmail } from "../../util/util";
import { editor, moduleNameMap, settingType } from "../../config/config";
import { ContactLine } from "../molecules/ContactLine";

const { useState, useEffect } = React;

async function splitStringIntoChunks(str, chunkSize = 31900) {
  const chunks = [];
  for (let i = 0; i < str.length; i += chunkSize) {
    chunks.push(str.slice(i, i + chunkSize));
  }
  return chunks;
}

const listType = {
  mailmeregeList: {
    title: "Mailmerge",
    type: "mailmeregeList",
  },
  attachments: {
    title: "Attachments",
    type: "attachments",
  },
  fieldFiles: {
    title: "From Record",
    type: "fieldFiles",
  },
  inventory: {
    title: "Inventory Template",
    type: "inventoryTemplate",
  },
};

function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

function modifyArrInNotSinglePage({ arr, listViewPage, module }) {
  let newArr;
  if (listViewPage) {
    newArr = arr?.map((el) => {
      if (validateEmail(el)) {
        return el;
      }
      const pre_api_name = el?.api_name;
      return {
        ...el,
        api_name: `${module}.${pre_api_name}`,
      };
    });
  } else {
    newArr = arr;
  }
  const temp = newArr?.map((el) => (validateEmail(el) ? el : el?.api_name));
  return temp?.filter((el) => !!el);
}

export const EmailComponent = ({
  module,
  recordId,
  zapiKey,
  accessToken,
  relatedListModule,
  // relatedListModule: temp,
  setRelatedListModule,
  relationshipName,
  setRelationshipName,
  freeSolo,
  noParentRecord,
  handleEmailBack,
  //------
  crmUsersEmail,
  crmUsersEmailLoading,
  //------
  selectedEmailTemplateId,
  setSelectedEmailTemplateId,
  //------
  emailType,
  setEmailType,
  //------
  fromEmail,
  setFromEmail,
  //------
  emailTemplates,
  emailTemplatesLoading,
  //------
  inventoryTemplates,
  inventoryTemplatesLoading,
  selectedInventoryTemplate,
  setSelectedInventoryTemplate,
  //------
  emailOptions,
  storage,
  finalRecords,
  savedModule,
  dataCenterUrl,
  //------
  selectedFallbackEmail,
  setSelectedFallbackEmail,
  isOwnerEmailSelected,
  setIsOwnerEmailSelected,
  //------
  subject,
  setSubject,
  emailContent,
  setEmailContent,
  editorType,
  setEditorType,
  //------
  customActionPage,
  orgId,
  apiKey,
  configdata,
  settingSchema,
  setConfigdataLoading,
  inventoryModule,
  adminEmail,
  hideCloseButton,
  handlePreviewOpen,
  singlePage,
  listViewPage,
  recordDataKeys,
  toArray,
  setToArray,
  ccArray,
  setCcArray,
  bccArray,
  setBccArray,
  showNumberOfContactsLine = false,
}) => {
  // const [relatedListModule] = React.useState(temp);
  const name = moduleNameMap(relatedListModule ? relatedListModule : module);
  const nameKey = relatedListModule
    ? `${relatedListModule}.${name}`
    : moduleNameMap(module);

  const firstFourNames = finalRecords?.slice(0, 4)?.map((el) => el[nameKey]);
  const arrLength = finalRecords?.length - 4;

  let toLineStr;
  if (finalRecords?.length > 4) {
    toLineStr = `${firstFourNames?.join(
      ", "
    )}...& ${arrLength} more records selected`;
  } else {
    toLineStr = `${firstFourNames?.join(", ")}`;
  }

  const [selectedTemplateLoading, setSelectedTemplateLoading] = useState(false);
  //-------------
  const [to, setTo] = useState(toArray?.length < 1);
  const [cc, setCc] = useState(false);
  const [bcc, setBcc] = useState(false);
  // const [cc, setCc] = useState(ccArray?.length > 0);
  // const [bcc, setBcc] = useState(bccArray?.length > 0);
  const [fileSelected, setFileSelected] = React.useState(false);
  //-------------
  const [selectedFiles, setSelectedFiles] = React.useState([]);
  //-------------
  const [mailmeregeListLoading, setMailmeregeListLoading] = useState(false);
  const [mailmeregeList, setMailmeregeList] = useState([]);
  const [selectedMailmerege, setSelectedMailmerege] = useState([]);
  //-------------
  const [attachmentsLoading, setAttachmentsLoading] = useState(false);
  const [attachments, setAttachments] = useState([]);
  const [selectedAttachments, setSelectedAttachments] = useState([]);
  //-------------
  const [fieldFilesLoading, setFieldFilesLoading] = useState(false);
  const [fieldFiles, setFieldFiles] = useState([]);
  const [selectedFieldFiles, setSelectedFieldFiles] = useState([]);
  //-------------
  const [templateAttachments, setTemplateAttachments] = useState([]);
  const [editSelectedTemplate, setEditSelectedTemplate] = useState(true);
  const initialContentRef = React.useRef();
  const initialSubjectRef = React.useRef();
  //-------------
  const [fieldNameApis, setFieldNameApis] = useState([]);
  //-------------
  const [waitingSubmitResp, setWaitingSubmitResp] = useState(false);
  const filesRef = React.useRef([]);
  const deletableFilesRef = React.useRef([]);
  const resetTipTapRef = React.useRef();
  const { enqueueSnackbar } = useSnackbar();
  //-------------
  let considerOwnerEmail = isOwnerEmailSelected && selectedFallbackEmail !== "";
  let tempModule = !!relatedListModule ? relatedListModule : module;

  useEffect(() => {
    const fetchData = async ({ entity }) => {
      const resp = await zohoApi.record.getFieldsAndData({
        entity,
        returnValues: ["fields"],
        displayName: true,
        apiName: false,
      });

      let tempFieldNames = [];
      if (resp?.fieldNames) {
        Object.values(resp?.fieldNames)?.forEach((array) => {
          // const array = resp?.fieldNames[key];
          // const lookupfield_api_name = array[0]?.lookupfield_api_name;
          // if (lookupfield_api_name) {
          //   tempFieldNames.push("${!" + lookupfield_api_name + "}");
          // }
          // let temp = [];
          array?.forEach((el) => {
            if (el?.lookupfield_api_name) {
              const tempApi =
                "${!" + el?.lookupfield_api_name + "." + el?.api_name + "}";
              el.lookupfield_api_name_new = tempApi;
              // temp.push(el);
              tempFieldNames.push(el);
            }
            // if (el?.lookupfield_api_name) {
            //   tempFieldNames.push(
            //     "${!" + el?.lookupfield_api_name + "." + el?.api_name + "}"
            //   );
            // }
          });
          // tempFieldNames.push(temp);
        });

        setFieldNameApis(tempFieldNames);
      }
    };
    if (tempModule) {
      fetchData({
        entity: tempModule,
      });
    }
  }, [tempModule]);

  const handleOpenBcc = () => {
    setBcc(true);
  };

  const handleCloseBcc = () => {
    setBcc(false);
  };

  const handleOpenCc = () => {
    setCc(true);
  };

  const handleCloseCc = () => {
    setCc(false);
  };

  const handleCloseTo = () => {
    setTo(false);
  };

  const totalFileLength =
    selectedFiles?.length +
    selectedAttachments?.length +
    selectedFieldFiles?.length +
    selectedMailmerege?.length;
  // + selectedInventoryTemplate?.length;

  const dataLoading =
    mailmeregeListLoading || fieldFilesLoading || attachmentsLoading;
  // || inventoryTemplatesLoading;

  const cardArray = [
    {
      arr: selectedFiles,
      file: true,
      onDelete: (name) => {
        setSelectedFiles((pre) => {
          return pre.filter((item) => item.name !== name);
        });
      },
    },
    {
      arr: selectedMailmerege,
      helperText: "Mailmerge",
      onDelete: (name) => {
        setSelectedMailmerege((pre) =>
          pre.filter((item) => item.name !== name)
        );
      },
    },
    {
      arr: selectedFieldFiles,
      helperText: "From Record",
      onDelete: (name) => {
        setSelectedFieldFiles((pre) =>
          pre.filter((item) => item.name !== name)
        );
      },
    },
    {
      arr: selectedAttachments,
      helperText: "Attachments",
      onDelete: (name) => {
        setSelectedAttachments((pre) =>
          pre.filter((item) => item.name !== name)
        );
      },
    },
    // {
    //   arr: selectedInventoryTemplate,
    //   helperText: "Inventory",
    //   onDelete: (name) => {
    //     setSelectedInventoryTemplate((pre) =>
    //       pre.filter((item) => item.name !== name)
    //     );
    //   },
    // },
  ];

  const fetchSingleEmailTemplate = React.useCallback(
    async (templateId) => {
      setEditSelectedTemplate(false);
      setSelectedTemplateLoading(true);
      const template = await zohoApi.email.getSingleEmailTemplate({
        templateId,
        accessToken,
        dataCenterUrl,
      });
      setSelectedEmailTemplateId(templateId);
      setSubject(template.data.subject);
      setEmailContent(template.data.content);
      initialSubjectRef.current = template.data.subject;
      initialContentRef.current = template.data.content;
      setTemplateAttachments(
        template.data?.attachments?.map((el) => el?.file_id)
      );
      setEditorType(editor.template);
      setSelectedTemplateLoading(false);
    },
    [accessToken, dataCenterUrl]
  );

  const fetchAttachments = async () => {
    setAttachments([]);
    setAttachmentsLoading(true);
    const extraAttachments = deletableFilesRef.current?.map((el) => el.id);
    const attachments = await zohoApi.file.getAttachments({
      module,
      recordId,
      accessToken,
      dataCenterUrl,
    });
    const all = await attachments?.data
      ?.filter((el) => !!el?.$file_id)
      ?.map((el) => ({
        ...el,
        name: el.File_Name,
      }));
    const filetered = await all?.filter(
      (el) => !extraAttachments.includes(el.id)
    );
    setAttachments(filetered);
    setAttachmentsLoading(false);
  };

  const fetchMailmerges = React.useCallback(
    async (paramModule) => {
      if (mailmeregeList?.length === 0) {
        setMailmeregeListLoading(true);
        const mailmeregeList = await zohoApi.mailmerge.getMailmergeTemplateList(
          {
            module: paramModule || tempModule,
            accessToken,
            dataCenterUrl,
          }
        );
        const tem = await mailmeregeList?.data?.map((el) => ({
          id: el,
          name: el,
        }));

        setMailmeregeList(tem);
        setMailmeregeListLoading(false);
      }
    },
    [accessToken, mailmeregeList?.length, tempModule, dataCenterUrl]
  );

  const fetchFieldFiles = React.useCallback(
    async (paramModule) => {
      if (fieldFiles?.length === 0) {
        setFieldFilesLoading(true);
        const { data: fileFields } = await zohoApi.record.getFileFields({
          module: paramModule || tempModule,
          accessToken,
          dataCenterUrl,
        });
        const tem = await fileFields?.map((el) => ({
          ...el,
          name: el.display_label,
        }));
        setFieldFiles(tem);
        setFieldFilesLoading(false);
      }
    },
    [accessToken, fieldFiles?.length, tempModule, dataCenterUrl]
  );

  let firstMM = React.useRef(true);
  let firstFF = React.useRef(true);
  useEffect(() => {
    const fetchSavedConfigDetailsCustomActionPage = async () => {
      setEditSelectedTemplate(false);
      const tempModule = settingSchema.relatedListModule
        ? settingSchema.relatedListModule
        : settingSchema.module;
      if (settingSchema.toArrayApis?.length > 0) {
        // const tempToArray = emailOptions?.filter((el) =>
        //   settingSchema?.toArrayApis?.includes(el.api_name)
        // );
        // const tempToArrayManual = settingSchema?.toArrayApis?.filter((el) =>
        //   validateEmail(el)
        // );
        // const tempToArrayManual = settingSchema?.toArrayApis?.filter((el) => {
        //   if (validateEmail(el)) {
        //     return true;
        //   }
        //   return false;
        // });
        // setToArray([...tempToArray, ...tempToArrayManual]);
        setToArray(settingSchema?.toArrayApis);
      }
      if (settingSchema.ccArrayApis?.length > 0) {
        // const tempCcArray = emailOptions?.filter((el) =>
        //   settingSchema?.ccArrayApis?.includes(el.api_name)
        // );
        // const tempCcArrayManual = settingSchema?.ccArrayApis?.filter((el) =>
        //   validateEmail(el)
        // );
        // setCcArray([...tempCcArray, ...tempCcArrayManual]);
        setCcArray(settingSchema.ccArrayApis);
        setCc(true);
      }
      if (settingSchema.bccArrayApis?.length > 0) {
        // const tempBccArray = emailOptions?.filter((el) =>
        //   settingSchema?.bccArrayApis?.includes(el.api_name)
        // );
        // const tempBccArrayManual = settingSchema?.bccArrayApis?.filter((el) =>
        //   validateEmail(el)
        // );
        // setBccArray([...tempBccArray, ...tempBccArrayManual]);
        setBccArray(settingSchema.bccArrayApis);
        setBcc(true);
      }
      if (settingSchema.selectedMailmeregeName?.length > 0) {
        if (firstMM.current && accessToken) {
          firstMM.current = false;
          fetchMailmerges(tempModule);
        }
        const tempMMArray = mailmeregeList?.filter((el) =>
          settingSchema?.selectedMailmeregeName?.includes(el.name)
        );
        setSelectedMailmerege(tempMMArray);
      }
      if (settingSchema?.selectedFieldFilesApis?.length > 0) {
        if (firstFF.current && accessToken) {
          firstFF.current = false;
          fetchFieldFiles(tempModule);
        }
        const tempFFArray = fieldFiles?.filter((el) =>
          settingSchema?.selectedFieldFilesApis?.includes(el.api_name)
        );
        setSelectedFieldFiles(tempFFArray);
      }
      setConfigdataLoading(false);
    };
    if (settingSchema && accessToken) {
      fetchSavedConfigDetailsCustomActionPage();
    }
  }, [
    accessToken,
    settingSchema,
    emailOptions,
    mailmeregeList,
    fieldFiles,
    fetchSingleEmailTemplate,
    fetchMailmerges,
    fetchFieldFiles,
    setConfigdataLoading,
  ]);

  const getList = (type) => {
    if (type === listType.mailmeregeList.type) {
      return mailmeregeList;
    }
    if (type === listType.attachments.type) {
      return attachments;
    }
    if (type === listType.fieldFiles.type) {
      return fieldFiles;
    }
    // if (type === listType.inventory.type) {
    //   return inventoryTemplates;
    // }
    return [];
  };

  const getSelectedList = React.useCallback(
    (type) => {
      if (type === listType.mailmeregeList.type) {
        return selectedMailmerege;
      }
      if (type === listType.attachments.type) {
        return selectedAttachments;
      }
      if (type === listType.fieldFiles.type) {
        return selectedFieldFiles;
      }
      // if (type === listType.inventory.type) {
      //   return selectedInventoryTemplate;
      // }
      return [];
    },
    [
      selectedMailmerege,
      selectedAttachments,
      selectedFieldFiles,
      // selectedInventoryTemplate,
    ]
  );

  const handleSelectItem = ({ type, arr }) => {
    if (type === listType.mailmeregeList.type) {
      setSelectedMailmerege(arr);
    }
    if (type === listType.attachments.type) {
      setSelectedAttachments(arr);
    }
    if (type === listType.fieldFiles.type) {
      setSelectedFieldFiles(arr);
    }
    // if (type === listType.inventory.type) {
    //   setSelectedInventoryTemplate(arr);
    // }
    if (arr?.length === 0) {
      setFileSelected(false);
    } else {
      setFileSelected(true);
    }
  };

  const handleSelectFile = async (e) => {
    e.preventDefault();
    if (e.target.files) {
      const distinctFiles = {};
      [...e?.target?.files]?.forEach((item) => {
        distinctFiles[item.name] = item;
      });
      setSelectedFiles((pre) => {
        pre?.forEach((item) => {
          distinctFiles[item.name] = item;
        });
        return Object.values(distinctFiles);
      });
      setFileSelected(true);
      // setOpen(false);
    }
  };

  const checkLength = () => {
    if (totalFileLength === 1) {
      setFileSelected(false);
    }
  };

  /**
   * In this Record,
   */

  const updMailmergeIds = async ({
    module,
    recordId,
    storageModule,
    storageRecordId,
    dataCenterUrl,
    accessToken,
    selectedMailmerege,
  }) => {
    let newIds = [];
    let attachments;
    if (selectedMailmerege?.length > 0) {
      for (let index = 0; index < selectedMailmerege?.length; index++) {
        const el = selectedMailmerege[index];
        const mailmergeResp =
          await zohoApi.mailmerge.mailmergeToAttachmentsByDeluge({
            module,
            recordId,
            storageModule,
            storageRecordId,
            templateName: el.name,
            dataCenterUrl,
            accessToken,
          });
        const id = await mailmergeResp?.data?.details?.id;
        newIds.push(id);
      }

      attachments = await zohoApi.file.getAttachments({
        module: storageModule,
        recordId: storageRecordId,
        accessToken,
        dataCenterUrl,
      });

      const arr = await attachments?.data?.filter((el) =>
        newIds.includes(el.id)
      );
      const fileIdArr = await arr?.map((el) => el.$file_id);
      return { $file_id: fileIdArr, id: newIds };
    }
    return {};
  };

  const upload_file_get_id = async ({
    selectedFiles,
    storageModule,
    storageRecordId,
  }) => {
    let newIds = [];
    let attachments;
    if (selectedFiles?.length > 0) {
      for (let index = 0; index < selectedFiles?.length; index++) {
        const el = selectedFiles[index];
        const fileResp = await zohoApi.file.uploadAttachment({
          module: storageModule,
          recordId: storageRecordId,
          data: el,
        });
        const id = await fileResp?.data?.[0]?.details?.id;
        newIds.push(id);
      }

      attachments = await zohoApi.file.getAttachments({
        module: storageModule,
        recordId: storageRecordId,
        accessToken,
        dataCenterUrl,
      });

      const arr = await attachments?.data?.filter((el) =>
        newIds.includes(el.id)
      );
      const fileIdArr = await arr?.map((el) => el.$file_id);
      return { $file_id: fileIdArr, id: newIds };
    }
    return {};
  };

  const getRecordFileIds = async ({ module, recordId, selectedFieldFiles }) => {
    let newIds = [];
    if (selectedFieldFiles?.length > 0) {
      let fieldArrObj = {};
      let fieldApis = selectedFieldFiles?.map((field) => {
        fieldArrObj[field.api_name] = field;
        return field.api_name;
      });
      const { data: record } = await zohoApi.record.getRecordDetailsRestAPI({
        module,
        recordId,
        accessToken,
        dataCenterUrl,
      });
      Object.keys(record).forEach((key) => {
        if (fieldApis?.includes(key) && record[key]) {
          record[key].forEach((obj) => {
            newIds.push(obj?.File_Id__s);
          });
        }
      });
    }
    return newIds;
  };

  const clearTextEditor = async () => {
    setSubject("");
    setEmailContent("");
    setEditorType(editor.rich_text);
    setSelectedEmailTemplateId(undefined);
  };

  const clearComponentData = async () => {
    setIsOwnerEmailSelected(false);
    setSelectedFallbackEmail("");
    setSelectedInventoryTemplate([]);
    setToArray([]);
    setCcArray([]);
    setBccArray([]);
    setCc(false);
    setBcc(false);
    setSelectedMailmerege([]);
    setSelectedFieldFiles([]);
    setSelectedAttachments([]);
    setSelectedFiles([]);
  };

  const deleteTempFiles = async ({ storageModule, storageRecordId }) => {
    if (deletableFilesRef.current?.length > 0) {
      for (let index = 0; index < deletableFilesRef.current?.length; index++) {
        const elementId = deletableFilesRef.current[index];
        const del = await zohoApi.file.deleteAttachment({
          module: storageModule,
          recordId: storageRecordId,
          attachment_id: elementId,
          accessToken,
          dataCenterUrl,
        });
      }
    }
    deletableFilesRef.current = [];
    filesRef.current = [];
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setWaitingSubmitResp(true);

    //1.  UUID Generate
    const settingId = uuid();
    let tempFromEmail;
    let signature;

    const { data: signatureData } = await zohoApi.config.getConfigFromDB_2({
      moduleApiName: "userSignature",
      settingType: "",
      orgId,
      apiKey,
      dataCenterUrl,
    });

    const users = signatureData?.map((obj) => {
      const setting_schema = obj?.setting_schema;
      const parsedSettingSchema = JSON.parse(setting_schema);
      return parsedSettingSchema?.users;
    });

    if (!considerOwnerEmail) {
      tempFromEmail = fromEmail;
      signature = users?.filter((obj) => {
        return obj?.email === tempFromEmail;
      })?.[0]?.signature;
    }

    /*
     dont move getSchema, getLogSchemaMultipleRecord, and getMailObj from here.
    */

    const getSchema = ({ toArray, ccArray, bccArray }) => ({
      module,
      fromEmail,
      toArrayApis: toArray,
      ccArrayApis: ccArray,
      bccArrayApis: bccArray,
      subject,
      emailContent,
      templateAttachments,
      selectedInventoryTemplate,
      selectedMailmeregeName: selectedMailmerege?.map((el) => el.name),
      selectedFieldFilesApis: selectedFieldFiles?.map((el) => el.api_name),
      emailType,
      relatedListModule,
      relationshipName,
      ownerEmailSelected: isOwnerEmailSelected,
      fallbackEmail: selectedFallbackEmail,
      selectedEmailTemplateId,
      editSelectedTemplate,
    });

    const getLogSchemaMultipleRecord = async ({
      schema,
      recordId,
      toArray,
      ccArray,
      bccArray,
    }) => {
      const schemaChunks = await splitStringIntoChunks(JSON.stringify(schema));
      return {
        module: "easyemailforzohocrm__Email_Logs",
        recordData: {
          easyemailforzohocrm__Setting_ID: settingId,
          Name: recordId,
          easyemailforzohocrm__Module_Record_ID: recordId,
          easyemailforzohocrm__Setting_Schema: schemaChunks?.[0] || "",
          easyemailforzohocrm__Setting_Schema_2: schemaChunks?.[1] || "",
          easyemailforzohocrm__Setting_Schema_3: schemaChunks?.[2] || "",
          easyemailforzohocrm__Setting_Schema_4: schemaChunks?.[3] || "",
          easyemailforzohocrm__From_Email: fromEmail,
          easyemailforzohocrm__Module_Name: tempModule,
          easyemailforzohocrm__To_Emails: JSON.stringify(toArray),
          easyemailforzohocrm__CC_Emails: JSON.stringify(ccArray),
          easyemailforzohocrm__BCC_Emails: JSON.stringify(bccArray),
          easyemailforzohocrm__Status: "Pending",
          easyemailforzohocrm__Status_Message: "",
          easyemailforzohocrm__Response_JSON: "",
        },
      };
    };

    const getLogSchemaSingleRecord = async ({
      schema,
      recordId,
      toArray,
      ccArray,
      bccArray,
      mailResp,
      mail_config,
    }) => {
      const schemaChunks = await splitStringIntoChunks(JSON.stringify(schema));
      return {
        module: "easyemailforzohocrm__Email_Logs",
        recordData: {
          easyemailforzohocrm__Setting_ID: settingId, //
          Name: recordId,
          easyemailforzohocrm__Module_Record_ID: recordId,
          easyemailforzohocrm__Setting_Schema: schemaChunks?.[0] || "",
          easyemailforzohocrm__Setting_Schema_2: schemaChunks?.[1] || "",
          easyemailforzohocrm__Setting_Schema_3: schemaChunks?.[2] || "",
          easyemailforzohocrm__Setting_Schema_4: schemaChunks?.[3] || "",
          easyemailforzohocrm__From_Email: fromEmail,
          easyemailforzohocrm__Module_Name: module,
          easyemailforzohocrm__To_Emails: JSON.stringify(toArray),
          easyemailforzohocrm__CC_Emails: JSON.stringify(ccArray),
          easyemailforzohocrm__BCC_Emails: JSON.stringify(bccArray),
          easyemailforzohocrm__Status:
            mailResp?.status === "success" ? "Sent" : "Error",
          easyemailforzohocrm__Status_Message: mailResp?.message,
          easyemailforzohocrm__Response_JSON: mailResp,
          easyemailforzohocrm__Send_Mail_Config: mail_config,
        },
      };
    };

    const getMailObj = async ({
      tempRecordId,
      moduleFieldsAndData,
      tempContentWithSignature,
      $file_id_pc,
      file_id_record,
      $file_id_mm,
      $file_id_at,
      templateAttachments,
      newToArray,
      newCcArray,
      newBccArray,
      //---------
      selectedEmailTemplateId,
      editSelectedTemplate,
    }) => {
      const returnObj = {
        module: tempModule,
        recordId: tempRecordId,
        fromEmail: tempFromEmail,
        toArray: newToArray,
        ccArray: newCcArray,
        bccArray: newBccArray,
        // subject: await staticToDynamicEmail(
        //   subject,
        //   moduleFieldsAndData?.recordData
        // ),
        // content: await staticToDynamicEmail(
        //   tempContentWithSignature,
        //   moduleFieldsAndData?.recordData
        // ),
        attachments: [
          ...($file_id_pc || []),
          ...(file_id_record || []),
          ...($file_id_mm || []),
          ...($file_id_at || []),
          ...(templateAttachments || []),
        ],
        inventory_template: selectedInventoryTemplate,
        emailType,
        accessToken,
        dataCenterUrl,
        //---------
        selectedEmailTemplateId,
        editSelectedTemplate,
      };

      if (editSelectedTemplate || !selectedEmailTemplateId) {
        returnObj.subject = await staticToDynamicEmail(
          subject,
          moduleFieldsAndData?.recordData
        );
        returnObj.content = await staticToDynamicEmail(
          tempContentWithSignature,
          moduleFieldsAndData?.recordData
        );
      }

      return returnObj;
    };

    if (singlePage && finalRecords) {
      const recordObj = finalRecords?.[0];
      let tempRecordId = finalRecords?.[0]?.id;
      const schema = getSchema({ toArray, ccArray, bccArray });
      //------------------PC files
      const resp_pc = await upload_file_get_id({
        selectedFiles,
        storageModule: storage.module,
        storageRecordId: storage.recordId,
      });
      const $file_id_pc = await resp_pc?.$file_id;
      const id_pc = await resp_pc?.id;
      deletableFilesRef.current.push(...(id_pc || []));
      //------------------attachment module files
      const $file_id_at = selectedAttachments?.map((el) => el?.$file_id);
      //------------------from records file field
      let file_id_record = await getRecordFileIds({
        module: tempModule,
        recordId: tempRecordId,
        selectedFieldFiles,
      });
      //------------------mailmerge
      // let $file_id_mm;
      // if (editSelectedTemplate || !selectedEmailTemplateId) {
      const resp_mm = await updMailmergeIds({
        module: tempModule,
        recordId: tempRecordId,
        storageModule: storage.module,
        storageRecordId: storage.recordId,
        dataCenterUrl,
        accessToken,
        selectedMailmerege,
      });
      const $file_id_mm = await resp_mm?.$file_id;
      const id_mm = await resp_mm?.id;
      deletableFilesRef.current.push(...(id_mm || []));
      // }
      //------------------
      let moduleFieldsAndData = await zohoApi.record.getFieldsAndData({
        entity: tempModule,
        entityId: tempRecordId,
      });

      if (considerOwnerEmail) {
        const ownerEmail = recordObj?.Owner?.email;

        tempFromEmail = crmUsersEmail.includes(ownerEmail)
          ? ownerEmail
          : selectedFallbackEmail;

        signature = users?.filter((obj) => {
          return obj?.email === tempFromEmail;
        })?.[0]?.signature;

        // signature = await zohoApi.user.getCrmUsersSignature({
        //   email: tempFromEmail,
        // });
      }

      let tempContentWithSignature = emailContent.replace(
        "${!userSignature}",
        signature || ""
      );

      const newToArray = toArray
        ?.map((el) => {
          if (validateEmail(el?.value)) {
            return el?.value;
          }
          if (validateEmail(el)) {
            return el;
          }
          return null;
        })
        ?.filter((el) => !!el);

      const newCcArray = ccArray
        ?.map((el) => {
          if (validateEmail(el?.value)) {
            return el?.value;
          }
          if (validateEmail(el)) {
            return el;
          }
          return null;
        })
        ?.filter((el) => !!el);

      const newBccArray = bccArray
        ?.map((el) => {
          if (validateEmail(el?.value)) {
            return el?.value;
          }
          if (validateEmail(el)) {
            return el;
          }
          return null;
        })
        ?.filter((el) => !!el);

      const newTemplateAttachments =
        editSelectedTemplate || !selectedEmailTemplateId
          ? templateAttachments
          : [];

      let mailObj = await getMailObj({
        tempRecordId,
        moduleFieldsAndData,
        tempContentWithSignature,
        $file_id_pc,
        file_id_record,
        $file_id_mm,
        $file_id_at,
        templateAttachments: newTemplateAttachments,
        newToArray,
        newCcArray,
        newBccArray,
        //---------------
        selectedEmailTemplateId,
        editSelectedTemplate,
      });

      //--------------------
      const { data: mailResp, mail_config } = await zohoApi.email.sendEmail(
        mailObj
      );

      //--------------------
      // const mailResp = {
      //   status: null,
      //   message: "it is just placeholder mail resp.",
      // };

      // return;
      //--------------------

      const logSchema = await getLogSchemaSingleRecord({
        schema,
        recordId: recordObj?.id,
        toArray: newToArray,
        ccArray: newCcArray,
        bccArray: newBccArray,
        mailResp,
        mail_config,
      });

      await zohoApi.record.insertRecord(logSchema);

      if (mailResp?.status === "success") {
        enqueueSnackbar(`Email sent successfully`, {
          variant: "success",
          autoHideDuration: 3000,
        });
      } else {
        enqueueSnackbar(mailResp?.message, {
          variant: "error",
          autoHideDuration: 3000,
        });
      }
    }

    if (!singlePage && finalRecords) {
      for (const recordObj of finalRecords) {
        const recordId = recordObj?.id
          ? recordObj?.id
          : recordObj[`${tempModule}.id`];

        const schema = getSchema({
          toArray: modifyArrInNotSinglePage({
            arr: toArray,
            listViewPage,
            module,
          }),
          ccArray: modifyArrInNotSinglePage({
            arr: ccArray,
            listViewPage,
            module,
          }),
          bccArray: modifyArrInNotSinglePage({
            arr: bccArray,
            listViewPage,
            module,
          }),
        });

        schema.selectedAttachments = selectedAttachments?.map(
          (el) => el?.$file_id
        );
        schema.record_Id = recordId;

        const logSchema = await getLogSchemaMultipleRecord({
          schema,
          // recordObj,
          recordId,
          toArray: modifyArrInNotSinglePage({
            arr: toArray,
            listViewPage,
            module,
          }),
          ccArray: modifyArrInNotSinglePage({
            arr: ccArray,
            listViewPage,
            module,
          }),
          bccArray: modifyArrInNotSinglePage({
            arr: bccArray,
            listViewPage,
            module,
          }),
        });

        const newLogResp = await zohoApi.record.insertRecord(logSchema);

        await upload_file_get_id({
          selectedFiles,
          storageModule: "easyemailforzohocrm__Email_Logs",
          storageRecordId: newLogResp?.data?.[0]?.details?.id,
        });
      }

      try {
        // todo Create CRON with Setting ID/UUID in the Rest API URL
        const cronFetchUrl = `${dataCenterUrl}/crm/v2/functions/easyemailforzohocrm__sendpendingemails/actions/execute?auth_type=apikey&zapikey=${zapiKey}&setting_id=${settingId}`;
        const data = {
          url: cronFetchUrl,
          name: settingId,
          params: {},
          headers: {
            orgid: orgId,
            apikey: apiKey,
            connname: "easyemailforzohocrm",
            "content-type": "application/json",
            datacenterurl: dataCenterUrl,
          },
          body: {},
          type: "GET",
          execute_in: 1,
        };

        // {"url":crm_url,"name":title,"headers":Map(),"body":Map(),"params":Map(),"type":"GET","execute_in":1}

        const base_url = process.env.REACT_APP_ADMIN_SERVER_URL;
        const createCron = await axios({
          url: base_url + "/utils/cronjoborg",
          method: "post",
          headers: {
            orgid: orgId,
            connname: "easyemailforzohocrm",
            apikey: apiKey,
            datacenterurl: dataCenterUrl,
          },
          data: data,
        });
      } catch (error) {}

      enqueueSnackbar(
        `Emails are scheduled, please check Log module for Status`,
        {
          variant: "success",
          autoHideDuration: 3000,
        }
      );
    }

    await deleteTempFiles({
      storageModule: storage.module,
      storageRecordId: storage.recordId,
    });

    await clearTextEditor();
    await clearComponentData();
    setRelatedListModule(undefined);
    setRelationshipName(undefined);
    setFileSelected(false);
    resetTipTapRef?.current?.();

    setWaitingSubmitResp(false);
    await delay(1000);
    await window.ZOHO.CRM.UI.Popup.closeReload();
  };

  const onCAPS = async (e) => {
    e.preventDefault();
    setWaitingSubmitResp(true);

    const getSchema_onCAPS = () => ({
      module,
      fromEmail,
      toArrayApis: toArray,
      ccArrayApis: ccArray,
      bccArrayApis: bccArray,
      subject,
      emailContent,
      templateAttachments,
      selectedInventoryTemplate,
      selectedMailmeregeName: selectedMailmerege?.map((el) => el.name),
      selectedFieldFilesApis: selectedFieldFiles?.map((el) => el.api_name),
      emailType,
      relatedListModule,
      relationshipName,
      ownerEmailSelected: isOwnerEmailSelected,
      fallbackEmail: selectedFallbackEmail,
      selectedEmailTemplateId,
      editSelectedTemplate,
    });

    try {
      const schema = getSchema_onCAPS();
      const config = {
        orgId,
        dataCenterUrl,
        settingType: settingType.CustomAction,
        moduleApiName: module,
        settingId: configdata?.settingId || "",
      };
      //----
      const dbConfig = { ...config, apiKey, settingSchema: schema };

      // return;
      const dbConfigResp = await zohoApi.config.upsertConfigToDB(dbConfig);
      const zohoConfig = {
        ...config,
        settingId: dbConfigResp?.data?.data?.setting_id,
      };
      const noResp = await zohoApi.config.saveConfigToZoho(zohoConfig);
      //----
      setWaitingSubmitResp(false);
    } catch (onCAPSError) {}
  };

  return (
    <Box
      component={"form"}
      onSubmit={customActionPage ? onCAPS : onSubmit}
      sx={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      <EmailHeaderLine
        emailTemplates={emailTemplates}
        emailTemplatesLoading={emailTemplatesLoading}
        selectedTemplateLoading={selectedTemplateLoading}
        fetchSingleEmailTemplate={fetchSingleEmailTemplate}
        setEditSelectedTemplate={setEditSelectedTemplate}
        //------
        crmUsersEmail={crmUsersEmail}
        crmUsersEmailLoading={crmUsersEmailLoading}
        //------
        fromEmail={fromEmail}
        setFromEmail={setFromEmail}
        //------
        inventoryTemplates={inventoryTemplates}
        inventoryTemplatesLoading={inventoryTemplatesLoading}
        inventoryModule={inventoryModule}
        selectedInventoryTemplate={selectedInventoryTemplate}
        setSelectedInventoryTemplate={setSelectedInventoryTemplate}
        //------
        isOwnerEmailSelected={isOwnerEmailSelected}
        setIsOwnerEmailSelected={setIsOwnerEmailSelected}
        selectedFallbackEmail={selectedFallbackEmail}
        setSelectedFallbackEmail={setSelectedFallbackEmail}
        setEmailType={setEmailType}
        adminEmail={adminEmail}
      />
      {showNumberOfContactsLine ? (
        <ContactLine
          value={`To Records: ${toLineStr}`}
          to={showNumberOfContactsLine ? to : true}
          cc={cc}
          bcc={bcc}
          handleOpenTo={() => {
            setTo((pre) => !pre);
          }}
          handleOpenCc={() => {
            setCc((pre) => !pre);
          }}
          handleOpenBcc={() => {
            setBcc((pre) => !pre);
          }}
        />
      ) : null}
      {(showNumberOfContactsLine ? to : true) ? (
        <EmailToLine
          freeSolo={freeSolo}
          cc={cc}
          bcc={bcc}
          handleOpenBcc={handleOpenBcc}
          handleOpenCc={handleOpenCc}
          options={emailOptions}
          array={toArray}
          setArray={setToArray}
          showNumberOfContactsLine={showNumberOfContactsLine}
          handleCloseTo={handleCloseTo}
        />
      ) : null}
      {cc ? (
        <EmailCcLine
          freeSolo={freeSolo}
          handleCloseCc={handleCloseCc}
          options={emailOptions}
          array={ccArray}
          setArray={setCcArray}
        />
      ) : null}
      {bcc ? (
        <EmailBccLine
          freeSolo={freeSolo}
          handleCloseBcc={handleCloseBcc}
          options={emailOptions}
          array={bccArray}
          setArray={setBccArray}
        />
      ) : null}
      <EmailSubjectLine
        onChange={(e) => {
          setSubject(e.target.value);
        }}
        value={subject}
        richTextEditor={editorType === editor.rich_text}
        onSelectRichTextEditor={() => {
          clearTextEditor();
          setEditSelectedTemplate(true);
          resetTipTapRef?.current?.();
        }}
        disabled={!editSelectedTemplate}
      />
      {editorType === editor.rich_text ? (
        <TipTap
          content={emailContent}
          setEmailContent={setEmailContent}
          ref={resetTipTapRef}
          fieldNameApis={fieldNameApis}
          recordDataKeys={recordDataKeys}
        />
      ) : null}
      {editorType === editor.template ? (
        <Box
          sx={{
            flexGrow: 1,
            overflowY: "auto",
            borderTop: "1px solid #d7e2ed",
            position: "relative",
            overflow: "auto",
          }}
        >
          <Box
            sx={{
              position: "absolute",
              inset: ".5em",
              overflowY: "auto",
            }}
          >
            <Box
              sx={{
                position: "absolute",
                right: ".5rem",
                top: ".5rem",
                "& > :not(style)": { m: 0.5 },
              }}
            >
              {editSelectedTemplate ? (
                <Fab
                  aria-label="edit template"
                  size="small"
                  disableRipple
                  onClick={() => {
                    setEditSelectedTemplate((pre) => !pre);
                    setSubject(initialSubjectRef.current);
                    setEmailContent(initialContentRef.current);
                  }}
                >
                  <CloseIcon />
                </Fab>
              ) : (
                <Fab
                  aria-label="edit template"
                  size="small"
                  disableRipple
                  onClick={() => {
                    initialSubjectRef.current = subject;
                    initialContentRef.current = emailContent;
                    setEditSelectedTemplate((pre) => !pre);
                  }}
                >
                  <EditIcon />
                </Fab>
              )}
            </Box>
            <Box
              dangerouslySetInnerHTML={{ __html: emailContent }}
              contentEditable={editSelectedTemplate}
              onBlur={(e) => {
                setEmailContent(e.currentTarget.innerHTML);
              }}
            />
          </Box>
        </Box>
      ) : null}
      <EmailFooterLine
        diasableSend={
          !emailContent ||
          !subject ||
          !fromEmail ||
          waitingSubmitResp ||
          !(toArray?.length > 0) ||
          (isOwnerEmailSelected && selectedFallbackEmail === "")
        }
        listType={listType}
        setFileSelected={setFileSelected}
        fileSelected={fileSelected}
        handleSelectFile={handleSelectFile}
        //-------------
        fetchMailmerges={fetchMailmerges}
        fetchFieldFiles={fetchFieldFiles}
        fetchAttachments={fetchAttachments}
        //-------------
        checkLength={checkLength}
        totalFileLength={totalFileLength}
        dataLoading={dataLoading}
        cardArray={cardArray}
        handleSelectItem={handleSelectItem}
        handleEmailBack={() => {
          handleEmailBack();
          clearTextEditor();
          clearComponentData();
        }}
        showAttachmentButton={!noParentRecord && !relatedListModule}
        showDesktopFileButton={!customActionPage}
        getList={getList}
        getSelectedList={getSelectedList}
        customActionPage={customActionPage}
        ctaButtonText={customActionPage ? "Save" : "Send"}
        ctaButtonInLoadingState={waitingSubmitResp}
        inventoryModule={inventoryModule}
        inventoryModuleNoFile={
          inventoryModule && selectedInventoryTemplate?.length < 1
        }
        hideCloseButton={hideCloseButton}
        //-------------
        // disablePreview={!selectedEmailTemplateId}
        handlePreviewOpen={handlePreviewOpen}
      />
    </Box>
  );
};
